export enum ClientSections {
  Pending = 'pending',
  Approved = 'approved',
  Draft = 'draft',
}
